import { BillerNetworkAccountConstants as Constants } from '../types'

const initialState = {
    billerNetworkAccounts: [],
    loading: false,
    error: null,
}

export function billerNetworkAccountReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.LOADING:
            return { ...state, loading: true, error: null }

        case Constants.GET:
            return {
                ...state,
                loading: false,
                error: null,
                billerNetworkAccounts: action?.payload?.data || action?.payload || [],
            }

        case Constants.FAIL:
            return { ...state, loading: false, error: action?.error }

        default:
            return state
    }
}
